'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactEventHandler, useCallback, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { getImageLoadDecision, handleRealImageLoad, type ImageLoading } from '@/app/components/media/app-image/shared/image-load-state';
interface UseImageLoadStateOptions {
  imageKey: string;
  fade?: boolean | null;
  placeholder?: boolean | null;
  preload?: boolean | null;
  loading?: ImageLoading;
  root?: Element | null;
  preloadOffset?: string;
  onLoad?: ReactEventHandler<HTMLImageElement>;
}
export const useImageLoadState = t0 => {
  const $ = _c(28);
  const {
    imageKey,
    fade: t1,
    placeholder: t2,
    preload: t3,
    loading,
    root: t4,
    preloadOffset: t5,
    onLoad
  } = t0;
  const fade = t1 === undefined ? true : t1;
  const placeholder = t2 === undefined ? false : t2;
  const preload = t3 === undefined ? false : t3;
  const root = t4 === undefined ? null : t4;
  const preloadOffset = t5 === undefined ? "0px 0px 0px 0px" : t5;
  const shouldLoadImmediately = !!preload || loading === "eager";
  const [loadedImageKey, setLoadedImageKey] = useState(shouldLoadImmediately ? imageKey : null);
  let t6;
  if ($[0] !== preloadOffset || $[1] !== root || $[2] !== shouldLoadImmediately) {
    t6 = shouldLoadImmediately ? {
      skip: true
    } : {
      root,
      triggerOnce: true,
      threshold: 0.01,
      rootMargin: preloadOffset
    };
    $[0] = preloadOffset;
    $[1] = root;
    $[2] = shouldLoadImmediately;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const {
    ref: loadRef,
    inView: isInViewport
  } = useInView(t6);
  let t7;
  if ($[4] !== placeholder || $[5] !== shouldLoadImmediately) {
    t7 = placeholder && !shouldLoadImmediately ? {
      triggerOnce: true,
      threshold: 0.01,
      rootMargin: "25% 0px"
    } : {
      skip: true
    };
    $[4] = placeholder;
    $[5] = shouldLoadImmediately;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const {
    ref: shimmerRef,
    inView: shouldAnimateShimmer
  } = useInView(t7);
  let t8;
  if ($[7] !== fade || $[8] !== imageKey || $[9] !== isInViewport || $[10] !== loadedImageKey || $[11] !== loading || $[12] !== placeholder || $[13] !== preload || $[14] !== shouldAnimateShimmer) {
    t8 = getImageLoadDecision({
      imageKey,
      fade,
      placeholder,
      preload,
      loading,
      isInViewport,
      loadedImageKey,
      shouldAnimateShimmer
    });
    $[7] = fade;
    $[8] = imageKey;
    $[9] = isInViewport;
    $[10] = loadedImageKey;
    $[11] = loading;
    $[12] = placeholder;
    $[13] = preload;
    $[14] = shouldAnimateShimmer;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const loadDecision = t8;
  let t9;
  if ($[16] !== loadRef || $[17] !== placeholder || $[18] !== shimmerRef || $[19] !== shouldLoadImmediately) {
    t9 = node => {
      if (!shouldLoadImmediately) {
        loadRef(node);
      }
      if (placeholder && !shouldLoadImmediately) {
        shimmerRef(node);
      }
    };
    $[16] = loadRef;
    $[17] = placeholder;
    $[18] = shimmerRef;
    $[19] = shouldLoadImmediately;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const wrapperRef = t9;
  let t10;
  if ($[21] !== imageKey || $[22] !== onLoad) {
    t10 = event => {
      handleRealImageLoad(event, () => setLoadedImageKey(imageKey), onLoad);
    };
    $[21] = imageKey;
    $[22] = onLoad;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const handleLoad = t10;
  let t11;
  if ($[24] !== handleLoad || $[25] !== loadDecision || $[26] !== wrapperRef) {
    t11 = {
      ...loadDecision,
      wrapperRef,
      handleLoad
    };
    $[24] = handleLoad;
    $[25] = loadDecision;
    $[26] = wrapperRef;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};